export const VALID_PROMOCODES = [
  `NEWYEAR`,
  `super100`
];
